import { LayoutActionKey } from "../../../actions/ActionKeys";
import { LayoutAction } from "../../../actions/layout";

export const selectedTabId = (
  state: string = "editor",
  action: LayoutAction
): string => {
  switch (action.type) {
    case LayoutActionKey.SELECT_TAB:
      return action.payload.id;
    case LayoutActionKey.ADD_TAB:
      return action.payload.tab.id;
    default:
      return state;
  }
};
